import { render, staticRenderFns } from "./ListCourse.vue?vue&type=template&id=0c5c0fb8&scoped=true"
import script from "./ListCourse.vue?vue&type=script&lang=js"
export * from "./ListCourse.vue?vue&type=script&lang=js"
import style0 from "./ListCourse.vue?vue&type=style&index=0&id=0c5c0fb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c0fb8",
  null
  
)

export default component.exports